import { axiosInstance } from '~/src/config/config_axios'
import {
  IGetStockDetailResponse,
  IGetStockParams,
  IGetStockResponse,
  PatchStockRequest,
} from '~/src/repositories/Stock/models/Stock'
import { convertStock } from '~/src/repositories/Stock/helpers/ConvertStock'
import { convertStockDetail } from '~/src/repositories/Stock/helpers/ConvertStockDetail'
import { makeQueryUrl } from '~/src/libs/makeQueryUrl'

export class StockRepository {
  async getStockItem(_param: IGetStockParams): Promise<IGetStockResponse> {
    const { offset = 1, keyword, stockType, loadingPortId, supplierId, limit, excludesShippingAndLoadingFee } = _param

    const data = await axiosInstance.get(
      makeQueryUrl('/stocks', {
        keyword,
        stockType,
        loadingPortId,
        supplierId,
        excludesShippingAndLoadingFee,
        limit,
        offset,
      })
    )
    console.log('GetStock response ', data)
    return convertStock(data.data)
  }

  async getStockDetail(stockId: number): Promise<IGetStockDetailResponse> {
    const data = await axiosInstance.get(`/stocks/${stockId}`)
    return convertStockDetail(data.data)
  }
  async patchStockDetail(stockId: number, data: PatchStockRequest): Promise<void> {
    return axiosInstance.patch(`/stocks/${stockId}`, data)
  }
}
